import {createSelector} from "@reduxjs/toolkit";

export const notificationsSelector = createSelector((state) => state.snack?.notifications,
    (x => x));